'use client';

import { useEffect, useState } from 'react';

/**
 * The browser's clock, for a cached page that carries a schedule but must not
 * bake "now" into its HTML: null on the server and on the first client render
 * (so hydration matches), then the current time, refreshed every minute and
 * whenever the tab becomes visible again.
 */
export const useNow = (): Date | null => {
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    const refresh = () => setNow(new Date());
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    refresh();
    const timer = window.setInterval(refresh, 60_000);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return now;
};
